

import { getTransactionsApi } from '../api'

import {
  INIT_GRID,
  LOADING_GRID,
  UPDATE_GRID,
} from '@root/constants'


const loadTableAllCurrentSyncController = (query) => async (dispatch) => {
  try {
    dispatch({type: INIT_GRID, payload: { gridId:  `loadTableAllCurrentSync`, query: query} })
    dispatch({type: LOADING_GRID, payload: { gridId:  `loadTableAllCurrentSync`, isLoading: true } })
    const syncList = await getTransactionsApi(query);
    dispatch({type: UPDATE_GRID, payload: { gridId:  `loadTableAllCurrentSync`, items: syncList.value, countItems: syncList['@odata.count']} })
    dispatch({type: LOADING_GRID, payload: { gridId:  `loadTableAllCurrentSync`, isLoading: false } })
  } catch (err) {
    console.error(err)
  }
}

const updateTableAllCurrentSyncController = (query) => async (dispatch) => {
  try {
    dispatch({type: LOADING_GRID, payload: { gridId: 'loadTableAllCurrentSync', isLoading: true } })
    const syncList = await getTransactionsApi(query);
    dispatch({type: UPDATE_GRID, payload: { gridId: 'loadTableAllCurrentSync', items: syncList.value, countItems: syncList['@odata.count'], query: query } })
    dispatch({type: LOADING_GRID, payload: { gridId: 'loadTableAllCurrentSync', isLoading: false } })
  } catch (err) {
    console.error(err)
  }
}

export {
  loadTableAllCurrentSyncController,
  updateTableAllCurrentSyncController
}